import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductCollectionsComponent } from './product-collections.component';
import { ProductCollectionsListComponent } from './list/product-collections-list.component';
import { ProductCollectionEditComponent } from './edit/product-collection-edit.component';

const ROUTES: Routes = [
  {
    path: 'getAllProductCollections',
    component: ProductCollectionsListComponent,
    pathMatch: 'full',
  },
  {
    path: 'new',
    component: ProductCollectionEditComponent,
    pathMatch: 'full',
  },
  {
    path: 'name/:name',
    component: ProductCollectionEditComponent,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(ROUTES),
    ProductCollectionsComponent,
    ProductCollectionsListComponent,
    ProductCollectionEditComponent,
  ],
  declarations: [],
  exports: [ProductCollectionsComponent]
})
export class ProductCollectionsModule {}

